import React from 'react';

interface DCAStatsBoxesProps {
  stats: {
    dca1km: number;
    dca5km: number;
    dca10km: number;
  };
}

const DCAStatsBoxes: React.FC<DCAStatsBoxesProps> = ({ stats }) => {
  return (
    <div className='flex gap-2 justify-center md:gap-6 w-full xl:px-16 xl:gap-6'>
      <div className='flex flex-col items-center flex-1 md:flex-none'>
        <div className='border-2 border-[#FF1B11] rounded-lg px-1 py-2 md:py-3 xl:px-10 w-full h-fit text-center xl:min-w-[210px] md:min-w-[185px] bg-[#FF1B11]/15'>
          <div className='text-[white] text-xl md:text-4xl font-bold'>
            {stats.dca1km.toLocaleString()}
          </div>
        </div>
        <div className='text-[#FF1B11] text-sm md:text-lg font-medium mt-2 md:mt-2.5'>
          DCA &lt; 1km
        </div>
      </div>

      <div className='flex flex-col items-center flex-1 md:flex-none'>
        <div className='border-2 border-[#F39E0A] rounded-lg px-1 py-2 md:py-3 xl:px-10 w-full h-fit text-center xl:min-w-[210px] md:min-w-[185px] bg-[#F39E0A]/15'>
          <div className='text-[white] text-xl md:text-4xl font-bold'>
            {stats.dca5km.toLocaleString()}
          </div>
        </div>
        <div className='text-[#F39E0A] text-sm md:text-lg font-medium mt-2 md:mt-2.5'>
          DCA &lt; 5km
        </div>
      </div>

      <div className='flex flex-col items-center flex-1 md:flex-none'>
        <div className='border-2 border-[#10B982] rounded-lg px-1 py-2 md:py-3 xl:px-10 w-full h-fit text-center xl:min-w-[210px] md:min-w-[185px] bg-[#10B982]/15'>
          <div className='text-[white] text-xl md:text-4xl font-bold'>
            {stats.dca10km.toLocaleString()}
          </div>
        </div>
        <div className='text-[#10B982] text-sm md:text-lg font-medium mt-2 md:mt-2.5'>
          DCA &lt; 10km
        </div>
      </div>
    </div>
  );
};

export default DCAStatsBoxes;
